import gen from "@/functions/general.js"

export const ASSESSMENT_TERM_MAP = {
  'Presentation': 'Tableau',
  'Etiology': "Etiologie",
  'Complication': 'Complication',
  'Treatment': 'Traitement',
  'Indication': 'Indication',  
  'None': '',  
}

export const DURATION_MAP = {
  'Once': '1x',
  'Until': "Jusqu'à",
  'Since': 'Depuis',
  'Duration': 'Pendant',
  'None': '',
}

export const ROOTGROUP_TO_ICON_MAP = {
  "None" : "help",
  "Pain" : "pain",
  "Multi" : "person",
  "HealthyFollowUp" : "person",
  "Neuro" : "brain",
  "Ophtalmo" : "eye",
  "Ent" : "ear",
  "Pneumo" : "lung",
  "Cardio" : "heart",    
  "Gastro" : "stomach",
  "Uro" : "kidney",
  "Gyneco" : "uterus",
  "Msk" : "bone",
  "Dermato" : "skin",
  "Hemato" : "hemato",
  "Endoc" : "endoc",

  "Cell" : "hemato",
  "Physical" : "pressure",
  "Lab": "beaker",
  "Substance" : "biochemical",
  "Medic" : "pill",
  "Infectious" : "infectious",
  "Dysplasic" : "cancer",
  "Dysimmune" : "immunity",
  "SubstanceReaction" : "allergy",
  "Genetic" : "genetic",
  "Exogenous" : "toxic",
  "Procedure" : "scalpel",
  "Idiopathic" : "person",

  "FamilyHistory" : "people",
}


export const ROOTGROUP_TO_ICON_MAP_NEW = {
  "None" : "questionmark-diamond",
  "Pain" : "person",
  "Multi" : "person",
  "HealthyFollowUp" : "person",
  "Neuro" : "brain",
  "Ophtalmo" : "eye",
  "Ent" : "ear",
  "Pneumo" : "lungs",
  "Cardio" : "heart",
  "Gastro" : "stomach",
  "Uro" : "kidney",
  "Gyneco" : "uterus",
  "Msk" : "bone",
  "Dermato" : "skin",
  "Hemato" : "red-cell",
  "Endoc" : "thyroid",

  "Cell" : "red-cell",
  "Physical" : "speedometer",
  "Lab": "erlenmeyer",
  "Substance" : "molecule",
  "Medic" : "pill-duo",
  "Infectious" : "allergens",
  "Dysplasic" : "ribbon",
  "Dysimmune" : "antibody",
  "SubstanceReaction" : "hand_allergy",
  "Genetic" : "dna",
  "Exogenous" : "biohazard",
  "Procedure" : "scalpel",
  "Idiopathic" : "person",

  "FamilyHistory" : "person-2",
}
export const SITE_TYPES = [
  "None",
  "HealthyFollowUp", "Pain", "Multi",
  "SuperiorFunction", "Sensory", "Motor", "Mobility", "APP", "Procedure","Morpho", 
  "BodyQualifier",
  "Specimen", "Aggressed",
]

export const FINDING_PROCEDURE_TYPES = [
  "None", "General", "APP", "Lab", "Imaging", "MedicAdministration"
]

export function getPatientDocIcon(templateStatus, internalCode) {
  //"file", "fileCheck", "pencil"
  if (templateStatus === 'Template') {
    return "pencil"
  } else if (internalCode === 'Bill') {
    return templateStatus === 'Complete' ? "fileCheck" : "file"
  } else {
    return "file"
  }
}

export function getActiveDoseTimingForDate(matchDate, conceptDoseTimings) {
  if (!conceptDoseTimings) return null
  let filteredDoseTimings = conceptDoseTimings
    .filter(doseTiming => doseTiming.timelineStart < matchDate)   //Only prior doseTimings (STRICT INFERIOR)
  
  if (!filteredDoseTimings.length) {
    return null
  } else {
    const sortedDoseTimings = filteredDoseTimings.sort((a, b) => new Date(b.timelineStart) - new Date(a.timelineStart))
    const priorDoseTiming = sortedDoseTimings[0]
    if (priorDoseTiming.conceptTimingType === "Stop") {
      return null 
    } else if (priorDoseTiming.timelineEnd && priorDoseTiming.timelineEnd < matchDate) {
      return null
    } else {
      return priorDoseTiming
    }   
  }
}

export function getMedicModificationIcon(sapExpr, conceptDoseTimings) {
  if (sapExpr.durationType === "Until") return "stop"
  const matchDate = sapExpr.timelineStart
  const activeDoseTiming = getActiveDoseTimingForDate(matchDate, conceptDoseTimings)
  if (!activeDoseTiming) return "play"
  return "evolve" //ToDo "arrowUp" and "arrowDown"
}


export function getMedicModificationOrder(icon) {
  if (icon === "stop") {
    return "0"
  } else if (icon === "evolve") {
    return "1"
  } else if (icon === "arrowUp") {
    return "2"
  } else if (icon === "arrowDown") {
    return "3"
  } else if (icon === "play"){
    return "4"
  } else{
    return "5"
  }
}

export function getRootGroupIcon(rootGroup) {
  return ROOTGROUP_TO_ICON_MAP[rootGroup]
}

export function getRootGroupNewIcon(rootGroup) {
  return ROOTGROUP_TO_ICON_MAP_NEW[rootGroup];
}

export function getAssessmentTerm(assementTerm) {
  return ASSESSMENT_TERM_MAP[assementTerm]
}


//EXPRESSION TERMS
export function getSubstTerm(expr) {
  if (!expr || !expr?.sctSubstance1) {return ""}
  //if (!expr.isMatched) {return expr.originalText}
  const separator = " + "
  let allSubstanceTerms = expr.sctSubstance1Term
  if (expr.sctSubstance2) {allSubstanceTerms += separator + expr.sctSubstance2Term}
  if (expr.sctSubstance3) {allSubstanceTerms += separator + expr.sctSubstance3Term}
  if (expr.sctSubstance4) {allSubstanceTerms += separator + expr.sctSubstance4Term}
  if (expr.sctSubstance5) {allSubstanceTerms += separator + expr.sctSubstance5Term}
  if (expr.sctSubstance6) {allSubstanceTerms += separator + expr.sctSubstance6Term}  
  return allSubstanceTerms
}

export function getSubstFamilyTerm(expr) {
  if (!expr || !expr?.sctSubstance1) {return ""}
  const separator = " + "
  let allFamilyTerms = expr.sctContentFamily1Term
  if (expr.sctContentFamily2Term) {allFamilyTerms += separator + expr.sctContentFamily2Term}
  if (expr.sctContentFamily3Term) {allFamilyTerms += separator + expr.sctContentFamily3Term}
  if (expr.sctContentFamily4Term) {allFamilyTerms += separator + expr.sctContentFamily4Term}
  if (expr.sctContentFamily5Term) {allFamilyTerms += separator + expr.sctContentFamily5Term}
  if (expr.sctContentFamily6Term) {allFamilyTerms += separator + expr.sctContentFamily6Term}  
  return allFamilyTerms
}

export function getExprTerm(expr) {
  let ret = getMatchedExprTerm(expr) || expr.originalText
  ret = gen.capitalize(ret)
  return ret
}

export function isForeignLang(expr, sctLanguage) {
  if  (!expr.isMatched || !sctLanguage) return false;
  //if "FrFr" === "fr"
  return expr.languageIso.slice(0, 2).toLowerCase() !== sctLanguage.slice(0, 2).toLowerCase();
}

export function getTextBasedOnLanguage(expr, sctLanguage) {
  return isForeignLang(expr, sctLanguage) ? getInterpretedExprTerm(expr) : gen.capitalize(expr.originalText);
}

export function getInterpretedExprTerm(expr) {
  let ret = getMatchedExprTerm(expr)
  if (ret === "") {return gen.capitalize(expr.originalText)}
  
  //Capitalize
  if (!expr.isFamilyHistory) {
    ret = gen.capitalize(ret)
  }

  //NormalityType
  if (expr.normalityType === 'Low') {
    ret = '↓ ' + ret
  } else if (expr.normalityType === 'High') {
    ret = '↑ ' + ret
  } else if (expr.normalityType === 'Abnormal' && expr.isNumerical) {
    ret = '↓↑ ' + ret
  }
  
  //Negation
  if (expr.isNegated) {
    ret = '∅ ' + ret
  }
  //Certainty
  if (!expr.isFact) {
    ret = '? ' + ret
  }
  //Family History
  if (expr.isFamilyHistory) {
    let subject = expr.sctPersonSubjectTerm
    subject = gen.capitalize(subject) + ": "
    ret = subject + ret
  }
  // //Stop
  // if (expr.durationType === 'PureStop') {
  //   ret = '⏹ ' + ret
  // }
  
  return ret
}

export function isMatchedExpr(expr) {
  let site = expr.sctSite
  let aggressor = expr.sctAggressor || expr.sctSubstance1
  let siteFinding = expr.sctSiteFinding
  
  return (aggressor || site || siteFinding) ? true : false
}


export function getMatchedExprTerm(expr) {
  const log = false
  if (log) console.log("***getMatchedExprTerm for: " + expr.originalText);
  if (!expr.isMatched) {return ""}

  let siteTerm = expr.sctSiteTerm
  let aggressorTerm = getSubstTerm(expr) || expr.sctAggressorTerm
  let siteFindingTerm = expr.sctSiteFindingTerm
  let painTerm = "Pain"                                               // TODO: language specific 
  if (!isMatchedExpr(expr))  {return ""}  //supplementary check (necessary> ??)

  //Nested Aggressor aggressorTerm
  if (aggressorTerm && expr.sctNestingAggressor) {
    aggressorTerm = expr.sctNestingAggressorTerm + " anti-" + aggressorTerm
  }

  //SubstanceReaction
  if(aggressorTerm && expr.aggressorRoot === 'SubstanceReaction') {
    aggressorTerm = expr.sctSubstanceReactionTerm + " - " + aggressorTerm  
  }

  //Determine base expression: aggressorTerm / siteTerm / siteFindingTerm
  let ret = ""
  if (aggressorTerm) {
    ret = aggressorTerm
  }
  if (siteFindingTerm) {
    if (aggressorTerm !== siteFindingTerm) {
      siteFindingTerm = prefixShortLaterality(siteFindingTerm, expr)
      ret = ret ? ret + " - " + siteFindingTerm : siteFindingTerm    
    }
  } else if (siteTerm) {
    siteTerm = prefixShortLaterality(siteTerm, expr)
    ret = ret ? ret + " - " + siteTerm : siteTerm
  }  
  // if (siteFindingTerm && ['Multi', 'Morpho', 'APP', 'Motor', 'Sensory'].includes(expr.siteFindingRoot)) {
  //   ret = siteFindingTerm //+ " - " + siteTerm
  // }

  //Special cases
  if (log) console.log("before special cases: " + ret);
  if (aggressorTerm && ["Surgery", "Physical"].includes(expr.aggressorRoot)) {
    ret = aggressorTerm
  } else if  (aggressorTerm && expr.siteFindingRoot === "Specimen" && expr.siteRoot === 'Blood' && expr.aggressorRoot !== 'SubstanceReaction') {
    //ret = `[${aggressorTerm}]`
    ret = `${aggressorTerm}`
  } else if  (aggressorTerm && expr.siteFindingRoot === "Specimen" && expr.siteRoot === 'Blood' && expr.aggressorRoot === 'SubstanceReaction') {
    ret = `${aggressorTerm}`    
  } else if  (aggressorTerm && expr.aggressorRootGroup === "Dysplasic" && expr.siteRootGroup === 'Hemato') {
    ret = aggressorTerm
  } else if(expr.siteFindingRoot === 'Pain') {
    if (siteTerm) {
      siteTerm = prefixShortLaterality(siteTerm, expr)
      ret = `${painTerm} - ${siteTerm}`       
    } else if (painTerm !== siteFindingTerm) {
      ret = `${painTerm} - ${siteFindingTerm}`
    } else {
      ret = `${painTerm}`
    }
  } else if (expr.siteFindingRoot === 'BodyQualifier' && expr.sctBodyQualifier) {
    ret = ret + " - " + expr.sctBodyQualifierTerm         // TODO: language specific
  }
  if (log) console.log("after special cases: " + ret);

  //Commercial Name special cases
  if (expr.expressionType === "SubstanceAdministrationPrescription") {
    ret = expr.originalText
  }

  //Return
  return ret
}

export function prefixShortLaterality(term, expr) {
  const lateralityTerm = getShortLateralityTerm(expr)
  if (lateralityTerm) {
    term = term.replace(/\b(left|right|droit|droite|gauche|bilateral|bilatéral|bilatérale)\b/gi, '')
    term = `${lateralityTerm} ${term}`
  }     
  return term
}

export function getShortLateralityTerm(expr){
  let lateralityTerm = getLateralityTerm(expr)
  if (!lateralityTerm) {return ""}

  lateralityTerm = expr.laterality.charAt(0).toUpperCase()
  if (lateralityTerm === 'B') {lateralityTerm = "R + L"}    
  return lateralityTerm
}

export function getLateralityTerm(expr){
  let siteFindingRoot = expr.siteFindingRoot
  let lateralityTerm = expr.lateralityTermFr || expr.lateralityTerm

  if (["Pain", "SuperiorFunction", "Sensory", "Motor", "Mobility", "APP", "Procedure", "Morpho", "Aggressed"].includes(siteFindingRoot)) {
    return lateralityTerm
  }
  return ""
}

export function getProxyTerm(expr, show = "default", lateralityTerm = "") {
  var log = false;
  if (log) console.log('getProxyTerm for: ' + expr.originalText);
  //show
  //  sets how composite terms like "pneumonie à pneumocoque" will be handled
  //  values: "noAggressor", "noSite", "aggressorFirst", "siteFirst"
  //  if 'aggressorFirst' --> Pneumocoque (poumon)
  //  if 'siteFirst' --> Pneumonie (pneumocoque)

  //showLaterality
  //  if 'lateralityTerm' === '' (standard case for most proxies in etio, complic) --> use getShortLateralityTerm
  //  if 'lateralityTerm' === 'auto ' use 'getShortLateralityTerm'
  //  if 'lateralityTerm' --> 'Right' or 'Left' --> use first uppercase letter

  if (!["noAggressor", "noSite", "aggressorFirst", "siteFirst"].includes(show)) {
    if (log) console.log('use default argument for show');
    //Use default value
    show = "siteFirst"
  }
  if (log) console.log('show: ' + show )
  if (log) console.log("lateralityTerm: " + lateralityTerm)

  if (!expr.isMatched) {
    return expr.originalText
  }

  const expressionType = expr.expressionType
  const siteFindingRoot = expr.siteFindingRoot
  const siteFindingProxyTerm = expr.sctSiteFindingProxyTerm
  const siteProxyTerm = expr.sctSiteProxyTerm

  const siteRootTerm = expr.siteRootTerm
  const isAggressor = Boolean(expr.sctAggressor) || Boolean(expr.sctSubstance1)
  let aggressorProxyTerm = expr.sctAggressorProxyTerm
  const nestingAggressorTerm = expr.sctNestingAggressorTerm

  const findingProcedureTerm = expr.sctFindingProcedureTerm
  
  //Nested Aggressor aggressorTerm
  if (aggressorProxyTerm && nestingAggressorTerm) {
    aggressorProxyTerm = nestingAggressorTerm + " anti-" + aggressorProxyTerm
  }

  let isAggressorBySite = ["Dysplasic"].includes(expr.aggressorRootGroup) || ["Surgery"].includes(expr.aggressorRoot)

  if (lateralityTerm === 'auto') {
    lateralityTerm = getShortLateralityTerm(expr)
  } else if (lateralityTerm) {    //Left, Right, Both, None
    lateralityTerm = lateralityTerm.charAt(0).toUpperCase();
  }
  if (lateralityTerm) {lateralityTerm += ' '}
  if (log) console.log('laterality: ' + lateralityTerm);

  if (expr.sctSubstance1) {
    aggressorProxyTerm = getSubstTerm(expr)
    //if (expr.sctAdministrationRoute) {aggressorProxyTerm += " " + expr.sctAdministrationRoute}
  }

  let ret = ""
  if (expressionType === "SubstanceAdministrationPrescription") {
    ret = `${aggressorProxyTerm}`

  } else if (expressionType === "Prescription") {
    ret = `${aggressorProxyTerm}`

  } else if (["HealthyFollowUp", "SuperiorFunction", "Multi"].includes(siteFindingRoot)) {
    //Poids     Suivi adulte       Caculie
    ret = `${siteFindingProxyTerm}`

  } else if (["Sensory", "Motor", "Mobility"].includes(siteFindingRoot)) {
    //D amplitude genou
    ret = `${lateralityTerm}${siteFindingProxyTerm}`

  } else if (siteFindingRoot === "BodyQualifier") {
    //Mesures - D Rein
    ret = (show === "noSite") ? `Measures ${lateralityTerm}` : `Measures - ${lateralityTerm}${siteRootTerm}`

  } else if (siteFindingRoot === "Morpho") {
    //Apect - D Rein
    ret = (show === "noSite") ? `Aspect ${lateralityTerm}` : `Aspect - ${lateralityTerm}${siteRootTerm}`

  } else if (siteFindingRoot === "Pain") {
    //Douleur - G membre sup.
    ret = (show === "noSite") ? `${lateralityTerm}${expr.siteRoot.substring(4)}` : `Pain - ${lateralityTerm}${expr.siteRoot.substring(4)}`

  } else if (siteFindingRoot === "Procedure") {
    //Intervent.-  D Rein
    ret = `Procedure - ${lateralityTerm}${siteRootTerm}`

  } else if (siteFindingRoot === "APP") {
    //Auscultation G carotide 
    ret = (show === "noSite") ? `${findingProcedureTerm} ${siteProxyTerm} ${lateralityTerm}` : `${findingProcedureTerm} ${siteProxyTerm} ${lateralityTerm}${siteRootTerm}`

  } else if (siteFindingRoot === "Aggressed" && isAggressor && siteRootTerm && isAggressorBySite) {
      if (show === "aggressorFirst") {
      //Pneumocoque (poumon D)     Cancer (sein G)      Vésicule biliaire (chirurgie)
      ret = `${aggressorProxyTerm} (${lateralityTerm}${siteRootTerm})`
    } else if (show === "siteFirst") {
      //Poumon D (pneumocoque)     Sein G (cancer)      Chirurgie (vésicule biliaire)
      ret = `${lateralityTerm}${siteRootTerm} (${aggressorProxyTerm})`
    } else if (show === "noSite") {
      //Pneumocoque     Cancer       Vésicule biliaire 
      ret = `${aggressorProxyTerm}`      
    } else if (show === "noAggressor") {
      //Poumon D        Sein G       Chirurgie 
      ret = `${lateralityTerm}${siteRootTerm}`
    }
  } else if (siteFindingRoot === "Aggressed" && isAggressor) {
    //Exérèse de polype (no site defined)
    ret = `${aggressorProxyTerm}`  
  } else if (siteFindingRoot === "None" && isAggressor) {
    //Pneumocoque
    ret = `${aggressorProxyTerm}`                           
  } else if (siteFindingRoot === "Specimen" &&  !isAggressor) {
    //Urines
    ret = `${siteProxyTerm}`                               
  } else if (siteFindingRoot === "Specimen" &&  isAggressor) {
    if  (expr.aggressorRoot === 'SubstanceReaction') {
      ret = `Reaction to ${aggressorProxyTerm}`
    } else if (expr.siteRoot === 'Blood') {
      //[Créatinine]
      aggressorProxyTerm = gen.capitalize(aggressorProxyTerm)
      ret = `${aggressorProxyTerm}`
      //ret = `[${aggressorProxyTerm}]`
    } else {
      //E.coli (urines)
      ret = `${aggressorProxyTerm} (${siteProxyTerm})`
    }
  }

  return gen.capitalize(ret)
}

export function getConceptExpressions(mainExpression, allExpressions) {
  // Get all expressions for the concept of the current expression
  // e.g. form diabète --> prédiabète, diabète type 2, diabète insulino-réquérent

  if (mainExpression.conceptGroupId === "") return [mainExpression];

  return allExpressions.filter(expr => {return (expr.conceptGroupId === mainExpression.conceptGroupId)})
}

export function getAssessmentExpressionsOfConceptExpr(mainExpression, allExpressions) {
  // Get all expressions for a concept --> then get all expression that are an assessment of any of these
  // e.g.all expressions that have ccl with an assessement for prédiabète, diabète type 2, diabète insulino-réquérent
  const conceptExpressions = getConceptExpressions(mainExpression, allExpressions)
  const conceptExprIds = new Set(conceptExpressions.map(expr => expr.expressionId)) 
  return allExpressions.filter(expr => expr.conclusionGroup && conceptExprIds.has(expr.conclusionGroup.assessmentExpressionId))
}

// export function getAssessmentDoseTimingsOfConceptExpr(mainExpression, allExpressions, allDoseTimings) {
//   // e.g.all doseTImings that have ccl with an assessement for prédiabète, diabète type 2, diabète insulino-réquérent
//   const conceptExpressions = getConceptExpressions(mainExpression, allExpressions)
//   const conceptExprIds = new Set(conceptExpressions.map(expr => expr.expressionId))
//   return allDoseTimings.filter(doseTiming => conceptExprIds.has(doseTiming.conclusionGroup.assessmentExpressionId))
// }

export function getDurationTypeStr(expr) {
  return DURATION_MAP[expr.durationType] || ''
}


export function findById(array, idKey, idValue) {
    return array.find(expr => String(expr[idKey]) === String(idValue));
}

export function sortArrayByOrderNumber(array, orderKey) {
  array.sort((a, b) => {return a[orderKey] - b[orderKey]});
}

export function sortArrayBySiteFindingRoot(array, typeKey) {
  array.sort((a, b) => {return SITE_TYPES.indexOf(a[typeKey]) - SITE_TYPES.indexOf(b[typeKey])});
}

export function sortExprByDate(exprArray) {
  //sorts from latest to newest timelineStart
  exprArray.sort((a, b) => {
      return new Date(b.timelineStart).getTime() - new Date(a.timelineStart).getTime() || new Date(b.updated).getTime() - new Date(a.updated).getTime();
  });
}

export function getLatestExpr(exprArray) {
    sortExprByDate(exprArray)
    return exprArray[0] || null
}

export function sortMedicExprArray(expressions) {
  // Sort by
  // - has contentFamilyIndex
  // - then by contentFamilyIndex
  // - then alphabetically (with localCompare)
  expressions.sort((a, b) => 
    compareIsSapActive(a, b) ||
    compareDurationType(a, b) ||
    compareSmallestFamilyIndex(a, b) ||
    a.originalText.localeCompare(b.originalText)
  )
}

function compareDurationType(a, b) {
  const aIsSince = a.durationType === "Since";
  const bIsSince = b.durationType === "Since";
  if (aIsSince && !bIsSince) return -1;
  if (!aIsSince && bIsSince) return 1;
  return 0;
}

function compareIsSapActive(a, b) {
  if (a.isSapActive === true && b.isSapActive === false) {
    return -1
  } else if (a.isSapActive === false && b.isSapActive === true) {
    return 1
  }
  return 0
}

function compareSmallestFamilyIndex(a, b) {
  const smallestA = getSmallestFamilyIndex(a)
  const smallestB = getSmallestFamilyIndex(b)
  if (smallestA === null && smallestB !== null) {
      return 1
  } else if (smallestA !== null && smallestB === null) {
      return -1
  }
  return smallestA - smallestB
}

function getSmallestFamilyIndex(expr) {
  const keys = ["sctContentFamily1Index", "sctContentFamily2Index", "sctContentFamily3Index", "sctContentFamily4Index", "sctContentFamily5Index", "sctContentFamily6Index"]
  let smallest = null
  for (const key of keys) {
    const value = expr[key]
    if (value >= 0 && (smallest === null || value < smallest)) {
      smallest = value;
    }
  }
  return smallest
}
